var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"jobdetail",staticClass:"detail-wrapper"},[(_vm.id)?_c('JobDetail',{attrs:{"id":_vm.id,"show-new-tab":false,"show-predict":true,"preview":false,"disabled":_vm.underPreview,"ssr-data":_vm.ssrData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }